// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ww-z","tooltipWrapper":"Xw-z","icon":"Yw-z","tooltip":"Zw-z","content":"_w-z"};